import { render, staticRenderFns } from "./ProductGroupsForm.vue?vue&type=template&id=2abbed53&"
import script from "./ProductGroupsForm.vue?vue&type=script&lang=js&"
export * from "./ProductGroupsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports